module.exports = __webpack_public_path__ + "media/serum-pack-medium.ee0866d3.mp4";